import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import * as S from "./Carousel.Style";
import { ReactComponent as Arrow } from "../../../assets/svgs/arrow-icon.svg";

const Carousel = ({
    children,
    numberOfSlidersToDisplay,
    spacingToSlider,
    justifyContentOfSlider,
    noIndicator,
    noControls
}) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [newArraySliders, setNewArraySliders] = useState([])
    const [startX, setStartX] = useState(null);
    const [deltaX, setDeltaX] = useState(0);

    useEffect(() => {
        setNewArraySliders(splitSlides(children, numberOfSlidersToDisplay))
    }, [numberOfSlidersToDisplay, children])

    const splitSlides = (slides, numSlidersToDisplay) => {
        return slides.reduce((array, slide, index) => {
            const grupo = Math.floor(index / numSlidersToDisplay);
            array[grupo] = [...(array[grupo] || []), slide];
            return array;
        }, []);
    };

    const handleNext = () => {
        setActiveIndex((state) => (state + 1) % newArraySliders.length);
    };

    const handlePrevious = () => {
        setActiveIndex((state) =>
            state === 0 ? newArraySliders.length - 1 : state - 1
        );
    };

    const handleTouchStart = (event) => {
        setStartX(event.touches[0].clientX);
        setDeltaX(0);
    };

    const handleTouchMove = (event) => {
        if (startX !== null) {
            setDeltaX(event.touches[0].clientX - startX);
        }
    };

    const handleTouchEnd = () => {
        if (deltaX > 50) {
            handlePrevious();
        } else if (deltaX < -50) {
            handleNext();
        }
        setStartX(null);
        setDeltaX(0);
    };

    return (
        <S.CarouselContainer
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >
            <S.SlideWrapper activeIndex={activeIndex}>
                {newArraySliders.map((child, index) => (
                    <S.Slide
                        key={`slide-${index}`}
                        spacing={spacingToSlider}
                        justifyContent={justifyContentOfSlider}
                        isActiveIndex={index === activeIndex}
                    >
                        {child}
                    </S.Slide>
                ))}
            </S.SlideWrapper>

            {!noControls && (
                <S.Navigation>
                    <S.NavigationButton direction="left" onClick={handlePrevious}>
                        <Arrow />
                    </S.NavigationButton>
                    {noIndicator
                        ?
                        <></>
                        :
                        <S.IndicatorWrapper>
                            {newArraySliders.map((_, index) => (
                                <S.Indicator
                                    key={index}
                                    isActive={index === activeIndex}
                                    onClick={() => setActiveIndex(index)}
                                />
                            ))}
                        </S.IndicatorWrapper>
                    }
                    <S.NavigationButton direction="right" onClick={handleNext}>
                        <Arrow />
                    </S.NavigationButton>
                </S.Navigation>
            )}
        </S.CarouselContainer>
    );
};

export default Carousel;

Carousel.propTypes = {
    children: PropTypes.arrayOf(PropTypes.element).isRequired,
    numberOfSlidersToDisplay: PropTypes.number,
    spacingToSlider: PropTypes.number,
};

Carousel.defaultProps = {
    numberOfSlidersToDisplay: 1,
    spacingToSlider: 0,
    noIndicator: false,
};